import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useMemo } from 'react';
import classnames from 'classnames';

function mergeProps(legacyProps) {
  var className = legacyProps.className,
    classNames = legacyProps.classNames,
    _legacyProps$style = legacyProps.style,
    style = _legacyProps$style === void 0 ? {} : _legacyProps$style,
    styles = legacyProps.styles;
  if (!!classNames || !!styles) {
    // tslint:disable-next-line:no-console
    console.warn("\n      ClassNames and styles are deprecated prop types.\n      Please use built-in React prop types: https://reactjs.org/docs/faq-styling.html.\n    ".trim());
  }
  var mergedClassName = classnames(className, classNames);
  var mergedStyle = _objectSpread2(_objectSpread2({}, styles), style);
  return {
    className: mergedClassName,
    style: mergedStyle
  };
}
function useLegacyProps(legacyProps) {
  return useMemo(function () {
    return mergeProps(legacyProps);
  }, [legacyProps.className, legacyProps.classNames, legacyProps.style, legacyProps.styles]);
}

export default useLegacyProps;
